import { gql } from '@apollo/client';
import type { Billet, QueryBilletsArgs } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

const BILLET_FIELDS = gql`
  fragment BilletFields on Billet {
    id
    idDoc
    idCompany
    boletoLink
    subject
    fileName
    dataEmissao
    status
    dataVencimento
    barCode
    digitableLine
    titleValue
    nrDocumento
    nrNfse
    validFrom
    validTo
    runnedAt
    seqCode
    nrDocEntry
    nrNoteEntry
    cardCode
    cardName
    datePayment
    idContract
    payedValue
    diaProRata
    source
    nfeLink
    nfeDataEmissao
    nfeHoraEmissao
    nfeTitleValue
    nfeIdContract
  }
`;

class GraphQLBilletsRequester {
  public getBillets = (companyId: string, status?: string): Promise<Billet[]> => {
    return graphQLRequester
      .query<{ billets: Billet[] }, QueryBilletsArgs>({
        query: gql`
          ${BILLET_FIELDS}
          query billets($companyId: ID!, $status: String) {
            billets(companyId: $companyId, status: $status) {
              ...BilletFields
            }
          }
        `,
        variables: { companyId, status },
      })
      .then((response) => response.billets?.filter((item): item is Billet => !!item) ?? []);
  };

  public getBilletsByCompanies = (companyIds: string[], status?: string): Promise<Billet[]> => {
    return graphQLRequester
      .query<{ billetsByCompanies: Billet[] }, { companyIds: string[]; status?: string }>({
        query: gql`
          ${BILLET_FIELDS}
          query billetsByCompanies($companyIds: [ID!]!, $status: String) {
            billetsByCompanies(companyIds: $companyIds, status: $status) {
              ...BilletFields
            }
          }
        `,
        variables: { companyIds, status },
      })
      .then((response) => response.billetsByCompanies?.filter((item): item is Billet => !!item) ?? []);
  };
}

export default GraphQLBilletsRequester;
